import script from "./IndustryNews.vue?vue&type=script&lang=ts&setup=true"
export * from "./IndustryNews.vue?vue&type=script&lang=ts&setup=true"

import "./IndustryNews.vue?vue&type=style&index=0&id=ea586786&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea586786"]])

export default __exports__